<template>
  <div
    class="con-wrap"
    v-loading="lockStatus"
    element-loading-text="数据加载中......"
    element-loading-spinner="el-icon-loading"
  >
    <div class="bottom-box">
      <corner-box class="left-box fl box-element">
        <div class="title-box">选择要展示的摄像头</div>
        <el-tree
          class="tree-box"
          :data="treeList"
          node-key="id"
          ref="tree"
          show-checkbox
          default-expand-all
          :props="defaultProps"
          :default-checked-keys="defaultCheckedTreeKey">
        </el-tree>
        <div class="btn-box">
          <el-button @click="query(true)">确认</el-button>
        </div>
      </corner-box>
      <corner-box class="right-box fl box-element">
        <div class="content" id="contentBox" @scroll="changePosition($event)">
          <div v-for="(item,i) in videoData"  :key="i">
            <p class="company-name">{{item.name}}</p>
            <div v-for="(node,index) in item.children" class="video-box" :key="index" >
              <div :id="'div'+i+'Plugin'+index" class="videoCon" :ref="'div'+i+'Plugin'+index" :style="{'height': videoHeight+'px'}">
              </div>
              <p >{{node.name}}
              </p>
            </div>
          </div>
          <el-pagination
            background
            @current-change="query(false)"
            :page-size='pageSize'
            :current-page.sync="currentPage"
            layout="total,prev,pager,next"
            :total="totalNum">
          </el-pagination>
        </div>
      </corner-box>
    </div>
  </div>
</template>

<script>
import cornerBox from "../../components/cornerBox";

export default {
  name: "securityVideo",
  components:{
    cornerBox
  },
  data() {
    return {
      lockStatus: false,
      notInit: true,
      canDo: null,
      videoData: {},
      treeList: [],
      defaultCheckedTreeKey: [],
      defaultProps:{children: 'children',label: 'name'},
      arrangement: 2,
      allKeys: [],  //全部父节点
      totalNum: 0,
      currentPage: 1,
      pageSize: 6,
      videoList: [],
      plugin:true ,       //是否加载成功
      oWebControlArr: [],   //插件对象集合
      distanceArr:[],
      initCount:0,
      pubKey:'',         //公钥加密
      playMode:'',
      video_init_data:{         //插件初始化参数，需平台提供
        appkey:'22268603',
        appSecret:'Zittuhi7IrlpwO0D3koZ',    //是都需要加密
        ip:'172.16.1.50',
        port:'443',
        layout:'',      //不设置默认为2*2
        enableHttps: 1,
      },
      //videoWidth videoHeight screenWidth screenHeight
      //这四个参数为了使插件大小和屏幕宽度一致变化
      videoWidth:442,
      videoHeight:249,
      screenWidth: '',//屏幕宽度
      screenHeight: '',//屏幕高度
      //设置窗口遮挡 根据浏览器大小变化视频插件的大小
      iLastCoverLeft : 0,
      iLastCoverTop : 0,
      iLastCoverRight : 0,
      iLastCoverBottom : 0,
    };
  },
  mounted(){
    this.screenWidth = document.body.clientWidth; //窗口宽度
    this.screenHeight = document.body.clientHeight; //窗口高度
    let _this = this;
    window.addEventListener('resize', function () {
      _this.screenWidth = document.body.clientWidth; //窗口宽度
      _this.screenHeight = document.body.clientHeight; //窗口高度
    });
    this.getTree();
    this.query(false);
  },
  destroyed(){
    if (this.oWebControlArr.length != 0){
      for(let i1 in this.oWebControlArr){
        for(let i2 in this.oWebControlArr[i1]){
          this.oWebControlArr[i1][i2].JS_Disconnect().then(function(){}, function() {});
          this.oWebControlArr[i1][i2].JS_DestroyWnd().then(function(){ // oWebControl 为 WebControl 的对象
          })
        }
      }
    }
  },
  watch:{
    screenWidth(){
      if(this.$refs.div0Plugin0){
        this.videoWidth = this.$refs.div0Plugin0[0].offsetWidth;
        this.videoHeight = this.$refs.div0Plugin0[0].offsetWidth*1080/1920;
        for(let i1 in this.oWebControlArr){
          for(let i2 in this.oWebControlArr[i1]){
            if(this.oWebControlArr[i1][i2] != null){
              this.oWebControlArr[i1][i2].JS_Resize(this.videoWidth, this.videoHeight);
              this.setWndCover('div'+i1+'Plugin'+i2, this.oWebControlArr[i1][i2],i1,i2);
            }
          }
        }
      }
    },
    screenHeight(){
      if(this.$refs.div0Plugin0){
        this.videoWidth = this.$refs.div0Plugin0[0].offsetWidth;
        this.videoHeight = this.$refs.div0Plugin0[0].offsetWidth*1080/1920;
        for(let i1 in this.oWebControlArr){
          for(let i2 in this.oWebControlArr[i1]){
            if(this.oWebControlArr[i1][i2] != null){
              this.oWebControlArr[i1][i2].JS_Resize(this.videoWidth, this.videoHeight);
              this.setWndCover('div'+i1+'Plugin'+i2, this.oWebControlArr[i1][i2],i1,i2);
            }
          }
        }
      }
    },
    $route(to, from) {
      if (from.path == '/securityVideo') {
        if (this.oWebControlArr.length != 0){
          for(let i1 in this.oWebControlArr){
            for(let i2 in this.oWebControlArr[i1]){
              this.oWebControlArr[i1][i2].JS_Disconnect().then(function(){}, function() {});
              this.oWebControlArr[i1][i2].JS_DestroyWnd().then(function(){})
            }
          }
        }
      }
      if (to.path == '/securityVideo') {
        this.oWebControlArr = []
        this.query()
      }
    },
    quickStatus(val) {
      if(val){
        if (this.oWebControlArr.length != 0){
          for(let i1 in this.oWebControlArr){
            for(let i2 in this.oWebControlArr[i1]){
              this.oWebControlArr[i1][i2].JS_HideWnd()
            }
          }
        }
      } else {
        if (this.oWebControlArr.length != 0){
          for(let i1 in this.oWebControlArr){
            for(let i2 in this.oWebControlArr[i1]){
              this.oWebControlArr[i1][i2].JS_ShowWnd()
            }
          }
        }
      }
    }
  },
  computed: {
    quickStatus() {
      return this.$store.state.quickStatus
    }
  },
  methods: {
    getTree() {
      this.$get("haikangcamera/getcameraindexcodebyassetnumber", ['0','0','999','1']).then(response => {
        this.treeList = response.data;
        for( let i in response.data) {
          this.allKeys.push(response.data[i].id);
        }
        this.defaultCheckedTreeKey = this.allKeys;
      })
      .catch(response => {
        console.log(response);
      });
    },
    query(reset) {
      let param = [];
      if(this.notInit){
        param.divisionIds = '0';
        param.assetNumber = '0';
      } else {
        let arr1 = this.$refs.tree.getCheckedKeys();        //选中的节点
        let halfNode = this.$refs.tree.getHalfCheckedNodes();
        let checkedParents = [];
        if(halfNode.length != 0){
          for(let i in halfNode){
            let nowHalfNodeId = halfNode[i].id;
            checkedParents.push(nowHalfNodeId)
          }
        }
        for( let key1 in arr1 ){
          for( let key2 in this.allKeys ) {
            if ( arr1[key1] === this.allKeys[key2]){
              checkedParents.push(arr1[key1])
              arr1.splice(key1,1);
            }
          }
        }
        param.divisionIds = checkedParents.join(',');
        param.assetNumber = arr1.join(',');
      }
      param.pageSize = this.pageSize;
      if(reset){
        this.currentPage = 1
      }
      param.startPage = this.currentPage
      if( param.assetNumber ){
        this.$get("haikangcamera/getcameraindexcodebyassetnumber", param).then(response => {
          this.notInit = false;
          this.videoData = response.data;
          this.video_init_data.ip = response.ip;
          this.video_init_data.port = response.port;
          this.video_init_data.appkey = response.appkey;
          this.video_init_data.appSecret = response.appsecret;
          this.totalNum = response.totalNumber;
          let token = true;
          if (this.oWebControlArr.length != 0){
            console.log(this.oWebControlArr);
            for(let i1 in this.oWebControlArr){
              for(let i2 in this.oWebControlArr[i1]){
                this.oWebControlArr[i1][i2].JS_DestroyWnd().then(function(){ // oWebControl 为 WebControl 的对象
                  // 销毁插件窗口成功
                  token = true;
                },function(){
                  // 销毁插件窗口失败
                  this.$message({
                    message: '视频插件重启失败，请刷新页面',
                    type: 'warning'
                  })
                  token = false;
                });
              }
            }
            if(token){
              for(let i1 in this.videoData){
                this.oWebControlArr[i1] = []
                this.distanceArr[i1] = []
                for(let i2 in this.videoData[i1].children){
                  this.distanceArr[i1][i2] = {iLastCoverLeft : 0,iLastCoverTop : 0,iLastCoverRight : 0,iLastCoverBottom : 0,}
                  this.videoWidth = this.$refs.div0Plugin0[0].offsetWidth;
                  this.videoHeight = this.$refs.div0Plugin0[0].offsetWidth*1080/1920;
                  this.initPlugin(i1,i2, this.videoData[i1].children[i2]);
                }
              }
            }
          } else{
            for(let i1 in this.videoData){
              this.oWebControlArr[i1] = []
              this.distanceArr[i1] = []
              for(let i2 in this.videoData[i1].children){
                this.$nextTick(()=>{
                  this.distanceArr[i1][i2] = {iLastCoverLeft : 0,iLastCoverTop : 0,iLastCoverRight : 0,iLastCoverBottom : 0,}
                  this.videoWidth = this.$refs.div0Plugin0[0].offsetWidth;
                  this.videoHeight = this.$refs.div0Plugin0[0].offsetWidth*1080/1920;
                  this.initPlugin(i1,i2, this.videoData[i1].children[i2]);
                })
              }
            }
          }
        })
        .catch(response => {
          console.log(response);
        });
      }
    },
    //   插件初始化
    initPlugin (index1,index2, obj) {
      let _this = this;
      let nowContainerName = 'div'+index1+'Plugin'+index2;
      this.oWebControlArr[index1][index2] = new WebControl({
        szPluginContainer: nowContainerName,
        iServicePortStart: 15900,
        iServicePortEnd: 15909,
        szClassId:"23BF3B0A-2C56-4D97-9C03-0CB103AA8F11",
        cbConnectSuccess: (e) => {
          _this.plugin=true;
          if(_this.oWebControlArr[index1][index2]){
            _this.oWebControlArr[index1][index2].JS_StartService("window", {
              dllPath: "./VideoPluginConnect.dll"
            }).then( (res) => {
              var height = _this.videoHeight;
              var width = _this.videoWidth;
              _this.oWebControlArr[index1][index2].JS_CreateWnd(nowContainerName,width,height).then(() => {
                _this.initVideo(index1,index2, obj)
              });
              _this.oWebControlArr[index1][index2].JS_SetWindowControlCallback({
                cbIntegrationCallBack: function(oData){ // oData 是封装的视频 web 插件回调消息的消息体
                  let event = oData.responseMsg.msg.result;
                  if(event == 1024){
                    _this.$store.commit('changeVideoHide');
                  }else if(event == 1025){
                    _this.$store.commit('changeVideoHide');
                  }
                }
              })
            }, function () {
            });
          }
        },
        cbConnectError: () => {
          _this.oWebControlArr[index1][index2] = null;
          $('#'+nowContainerName).html("插件未启动，正在尝试启动，请稍候...");
          WebControl.JS_WakeUp("VideoWebPlugin://");
          _this.initCount ++;
          if (_this.initCount < 3) {
            setTimeout(() => {
              _this.initPlugin();
            }, 3000)
          } else {
            $('#'+nowContainerName).html("插件启动失败，请检查插件是否安装！下载地址：https://open.hikvision.com/download/5c67f1e2f05948198c909700?type=10");
            _this.plugin=false;
          }
        },
        cbConnectClose: () => {
          if(_this.oWebControlArr[index1][index2]){
            _this.oWebControlArr[index1][index2].JS_Disconnect().then(function(){}, function() {});
            _this.oWebControlArr[index1][index2] = null;
          }

        }
      });
    },
    // 初始化参数
    initVideo ( index1,index2, videoObj) {
      let _this = this;
      this.getPubKey(index1,index2, () =>{
        let appkey = this.video_init_data.appkey;
        let secret = this.setEncrypt(this.video_init_data.appSecret);       //对 secret 进行 RSA 公钥加密
        let ip = this.video_init_data.ip;
        let szPort= this.video_init_data.port;
        let layout = '1x1';
        let encryptedFields = 'secret';
        let port = parseInt(szPort);
        let buttonIDs = "0,16,256,257,258,259,260,512,513,514,515,516,517,768,769";  //自定义工具条按钮
        this.oWebControlArr[index1][index2].JS_RequestInterface({
          funcName: "init",
          argument: JSON.stringify({
            appkey: appkey,
            secret: secret,
            ip: ip,
            playMode: 0,   // 0-预览，1-录像播放
            port: port,
            showToolbar: 0,    //不显示工具栏
            enableHTTPS: 1,
            encryptedFields: encryptedFields,        //加密字段，虽然文档显示为非必填字段，但传会显示“appkey或APPsecret有问题”
            buttonIDs: buttonIDs,
            reconnectTimes: 3,          //重连次数
            layout: layout
          })
        }).then(function (oData) {
          let code = oData.responseMsg.code;
          if(code == 0){
            _this.startRealPlay( index1,index2, videoObj )
          }
        });
      })
      this.changePosition()
    },
    // 获取公钥
    getPubKey (index1,index2, callback) {
      this.oWebControlArr[index1][index2].JS_RequestInterface({
        funcName: "getRSAPubKey",
        argument: JSON.stringify({
          keyLength: 1024
        })
      }).then((oData) => {
        if (oData.responseMsg.data) {
          this.pubKey = oData.responseMsg.data;
          callback()
        }
      })
    },
    // RSA加密
    setEncrypt (value) {
      let encrypt = new JSEncrypt();
      encrypt.setPublicKey(this.pubKey);
      return encrypt.encrypt(value);
    },
    // 视频预览
    startRealPlay(index1,index2, videoObj){
      this.oWebControlArr[index1][index2].JS_RequestInterface({
        funcName: "startPreview",
        argument: JSON.stringify({
          cameraIndexCode : videoObj.cameraIndexCode ,
          streamMode: 0,
          transMode: 1,
          gpuMode: 0,
          wndId: -1,
        })
      }).then(function (oData) {
        if(oData.responseMsg.code == 0){
          // console.log(document.getElementsByTagName('iframe'))
        }
      });
    },
    //设置窗口遮挡
    setWndCover( containerName, videoObj, index1, index2 ) {
      //获取播放窗口div元素的左边界、右边界距离web页面左边界的长度、上边界、下边界距离web页面上边界的长度
      let oDivRect = document.getElementById(containerName ).getBoundingClientRect();
      let box = document.getElementById('contentBox').getBoundingClientRect();
      let iCoverLeft = (oDivRect.left - box.left < 0) ? Math.abs(oDivRect.left - box.left): 0;
      let iCoverTop = (oDivRect.top - box.top < 0) ? Math.abs(oDivRect.top - box.top): 0;
      let iCoverRight = (oDivRect.right - box.right > 0) ? oDivRect.right - box.right : 0;
      let iCoverBottom = (oDivRect.bottom - box.bottom  > 0) ? oDivRect.bottom - box.bottom : 0;
      //Math.round 为四舍五入    Math.abs 为取绝对值
      iCoverLeft = (iCoverLeft > this.videoWidth) ? this.videoWidth : iCoverLeft;
      iCoverTop = (iCoverTop > this.videoHeight) ? this.videoHeight : iCoverTop;
      iCoverRight = (iCoverRight > this.videoWidth) ? this.videoWidth : iCoverRight;
      iCoverBottom = (iCoverBottom > this.videoHeight) ? this.videoHeight : iCoverBottom;
      videoObj.JS_RepairPartWindow(0, 0, this.videoWidth+1, this.videoHeight);
      if (iCoverLeft != 0) {
        videoObj.JS_CuttingPartWindow(0, 0, iCoverLeft, this.videoHeight+1);
      }
      if (iCoverTop != 0) {
        videoObj.JS_CuttingPartWindow(0, 0, this.videoWidth+1, iCoverTop);
      }
      if (iCoverRight != 0) {
        videoObj.JS_CuttingPartWindow(this.videoWidth+1 - iCoverRight, 0, iCoverRight, this.videoHeight+1);
      }
      if (iCoverBottom != 0) {
        videoObj.JS_CuttingPartWindow(0, this.videoHeight+1 - iCoverBottom, this.videoWidth+1, iCoverBottom);
      }
      // if (this.distanceArr[index1][index2].iLastCoverLeft != iCoverLeft) {
      //   this.distanceArr[index1][index2].iLastCoverLeft = iCoverLeft;
      //   videoObj.JS_SetWndCover("left", iCoverLeft);
      // }
      // if (this.distanceArr[index1][index2].iLastCoverTop != iCoverTop) {
      //   this.distanceArr[index1][index2].iLastCoverTop = iCoverTop;
      //   videoObj.JS_SetWndCover("top", iCoverTop+1);
      // }
      // if (this.distanceArr[index1][index2].iLastCoverRight != iCoverRight) {
      //   this.distanceArr[index1][index2].iLastCoverRight = iCoverRight;
      //   videoObj.JS_SetWndCover("right", iCoverRight);
      // }
      // if (this.distanceArr[index1][index2].iLastCoverBottom != iCoverBottom) {
      //   this.distanceArr[index1][index2].iLastCoverBottom = iCoverBottom;
      //   videoObj.JS_SetWndCover("bottom", iCoverBottom+1);
      // }
    },
    changePosition(e){
      window.clearTimeout(this.canDo)
      this.canDo = setTimeout(() => {
        for(let i1 in this.oWebControlArr){
          for(let i2 in this.oWebControlArr[i1]){
            if(this.oWebControlArr[i1][i2] != null){
              this.oWebControlArr[i1][i2].JS_Resize(this.videoWidth, this.videoHeight);
              this.setWndCover('div'+i1+'Plugin'+i2, this.oWebControlArr[i1][i2],i1,i2);
            }
          }
        }
      }, 50)
    }
  }
}
</script>

<style scoped lang="scss">
.con-wrap {
  width: 100%;
  padding-top: 10px;
  .bottom-box {
    overflow: hidden;
    height: 100%;
    .left-box {
      width: 17%;
      // height: 83vh;
      height: 780px;
      margin: 0 10px;
      .title-box{
        padding: 10px;
        font-size: 16px;
        color: $light;
      }
      .tree-box {
        height: 620px;
        overflow: auto;
        color: $light;
      }
      .btn-box {
        text-align: center;
      }
    }
    .right-box {
      width: 81%;
      overflow: hidden;
      .content{
        // height: 83vh;
        height: 780px;
        overflow-y: scroll;
        .company-name{
          background: #011525fc;
          height: 45px;
          line-height: 45px;
          color: $positive;
          padding-left: 20px;
          font-size: 16px;
          letter-spacing: 2px;
        }
        .no-data{
          height: 200px;
          line-height: 150px;
          width: 100%;
          color: $light;
          text-align: center;
          font-size: 25px;
          letter-spacing: 2px;
        }
        .video-box{
          display: inline-block;
          width: 32%;
          margin: 6px;
          .videoCon{
            // width: 23vw;
            font-size: 14px;
            text-align: center;
            color: #949494;
          }
          p{
            line-height: 30px;
            font-size: 15px;
            text-align: center;
            color: $light;
            .iconfont{
              cursor: pointer;
            }
          }
        }
      }
    }
  }
}
</style>
